import { CompanyTitledPage } from "../../TitledPage";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Button from "@mui/material/Button";

import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../../components/PartHeader";
import useInputObject from "../../../hooks/useInputObject";
import { getProductById, updateProduct } from "../../../http/api/ProductAPI";
import ProductInfo from "../ProductInfo/ProductInfo";
import { ScreenStatusContext } from "../../../context/ScreenStatusContext";
import { confirmWhenChanged } from "../../../utils/validation";

const infoTableCellSx = {
  fontSize: 18,
};

// 新規商品更新ページ
export default function ProductEditPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const productId = location.state.productId;

  const product = useInputObject({});

  // 更新中をあらわすstate
  const [isUpdating, setUpdating] = useState(false);
  // 画面ステータスをcontextから取得
  const {isChanged} = useContext(ScreenStatusContext);

  // 商品取得
  useEffect(() => {
    if (productId != null) {
      GetProductById(productId);
    }
  }, [productId]);
  async function GetProductById(id) {
    let response = await getProductById(id);
    product.setValue(response.listProductInfo[0]);
  }

  const handleClickReturn = (event) => {
    if (confirmWhenChanged(isChanged)) {
      navigate(-1);
    }
  };
  // 更新ボタンをクリックするイベント
  async function handleClickUpdate() {
    setUpdating(true);
    product.Value.updatedId = 1; //TODO JWTを追加した後削除
    let response = await updateProduct(product.Value);
    alert("商品を編集しました。");
    navigate("/company/product", {
      state: { productId },
    });
  }

  return (
    <CompanyTitledPage title="商品編集">
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              商品情報の入力
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={handleClickUpdate} disabled={isUpdating}>
              更新
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={handleClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>

      {/* 商品情報 */}
      <ProductInfo product={product} isUpdateMode={true} />
    </CompanyTitledPage>
  );
}
